import { OptionGroupType } from '@frontend/sports/betting-offer/feature/fixture-factories';

export interface StatisticsInput {
    eventId: string;
    playerName: string;
    marketId?: string;
    optionId?: string;
}

export interface PlayerInfo {
    player_name: string;
    full_name: string;
    market_id: string;
    outcome_id: string;
    average_stat_value: string;
    hit_rate_value: string;
}
export interface PlayerStatisticsContent {
    graph_props_url?: string;
    player_stats?: PlayerInfo[];
    main_market_url?: string;
}

export interface PlayerStatisticsResponse {
    content: PlayerStatisticsContent;
    statusCode: number;
}

export interface PlayerStatisticsStoreData {
    isLoading: boolean;
    isError: boolean;
    data: PlayerStatistics | undefined;
}

export interface PlayerStatisticMessages {
    error: string;
    noData: string;
}

export interface PlayerStatistics {
    graphPropsUrl?: string;
    playerStatistics?: PlayerStatisticsPlayerInfo[];
    mainMarketUrl?: string;
    isMainMarketOpen?: boolean;
    mainMarketTracking?: boolean;
    mainMarketLoadedTracking?: boolean;
}

export interface PlayerStatisticsPlayerInfo {
    playerName?: string;
    marketId?: string;
    fullName?: string;
    outcomeId?: string;
    isOpen?: boolean;
    tracking?: boolean;
    averageStatValue?: string;
    hitRateValue?: string;
    loadedTracking?: boolean;
    playerNotFound?: boolean;
}

export interface UpdateStatisticsStoreParams {
    eventId: string;
    marketFilter: string;
    playerName: string;
    marketId?: string;
    optionId?: string;
    marketType?: OptionGroupType;
    isOpen?: boolean;
    tracking?: boolean;
    loadedTracking?: boolean;
}

export interface MainMarketStatisticsInfo {
    eventId: string;
    isMainMarketOpen: boolean;
    mainMarketTracking: boolean | undefined;
    mainMarketLoadedTracking?: boolean;
}

export const mergeStatisticsData = (
    newApiData: PlayerStatistics | undefined,
    cachedData: PlayerStatistics | undefined,
    marketFilter: string | undefined,
): PlayerStatistics | undefined => {
    const isTeamMarket = (marketFilter ?? 'mainMarket') === 'mainMarket';
    if (isTeamMarket) return { ...cachedData, ...newApiData };

    if (!newApiData) return undefined;
    if (!cachedData?.playerStatistics) return newApiData;

    const mergedPlayerStats = [...(newApiData.playerStatistics ?? [])];

    cachedData.playerStatistics?.forEach((cachedPlayer) => {
        if (!cachedPlayer?.playerName || !cachedPlayer?.marketId) return;

        const existingIndex = mergedPlayerStats.findIndex(
            (newPlayer) => newPlayer?.playerName === cachedPlayer.playerName && newPlayer?.marketId === cachedPlayer.marketId,
        );

        if (existingIndex !== -1) {
            mergedPlayerStats[existingIndex] = {
                ...mergedPlayerStats[existingIndex],
                ...cachedPlayer,
            };
        } else {
            mergedPlayerStats.push(cachedPlayer);
        }
    });

    return {
        ...newApiData,
        playerStatistics: mergedPlayerStats,
    };
};

export const PLAYER_STATS_IFRAME_HEIGHT = 143;
